import { Injectable, inject } from '@angular/core';
import { NavController } from '@ionic/angular';
import { LocationService } from '../services/location/location.service';
import { PAGE } from 'src/app/routes';

@Injectable({
  providedIn: 'root',
})
export class LocationBlockedGuard {
  private locationService = inject(LocationService);
  private navController = inject(NavController);

  public async canActivate(): Promise<boolean> {
    const job = this.locationService.isCountryBlocked();
    job.showNoInternetRetry();
    job.addErrorHandler().reloadWindow();
    const isBlocked = await job.runNoThrow();

    if (isBlocked) {
      this.navController.navigateRoot(`/${PAGE.UNAVAILABLE}`);
      return false;
    }
    return true;
  }
}
